import React from 'react';
import styled, {css} from 'styled-components';
import {AppContext} from '../App/AppProvider';
import {Tile} from '../Shared/Tile';
import {SelectableTile} from '../Shared/Tile';
import CoinTile from './CoinTile';

export const CoinGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  grid-gap: 15px;
  margin-top: 40px;
`

// Create another helper Function named 'getLowerSectionCoins()'
function getLowerSectionCoins(coinList, filteredCoins) {
  return (filteredCoins && Object.keys(filteredCoins)) || Object.keys(coinList).slice(0,100);

}

function getCoinsToDisplay(coinList, topSection, favorites, filterCoins) {
  
  //console.log("coinList, topSection, favorites=====>", coinList, topSection, favorites);
  //return topSection ? favorites : Object.keys(coinList).slice(0, topSection ? 10 : 100);
  // Change above line into using Helper Function
  return topSection ? favorites : getLowerSectionCoins(coinList,filterCoins);
}

export default function ({topSection}) {
  return (
  <AppContext.Consumer>
    {({coinList, dummy, filteredCoins}) => (
    <CoinGridStyled>
      {getCoinsToDisplay(coinList, topSection, dummy, filteredCoins).map(coinKey => 
      <CoinTile key={coinKey} topSection={topSection} coinKey = {coinKey} />
  
  )}
</CoinGridStyled>
)}
  </AppContext.Consumer>
  );
}

